import {
  CommonHelperFunctions,
  ICRUDFormDiMetadata,
  ICRUDGetFormDiCustomRequest,
  ICRUDSyncFormMetadataWithActionResponse,
  ICRUDSyncFormMetadataWithTableResponse,
  ICRUDSyncFormMetadataWithWorkflowResponse,
  IDisplayItem,
  IGetFormMetadataFromActionRequest,
  IGetFormMetadataFromDataTableRequest,
  IGetFormMetadataFromExcelRequest,
  IGetFormMetadataFromWorkflowBoRequest,
  IMigrateFormMetadataRequest,
  ISyncFormMetadataWithActionRequest,
  ISyncFormMetadataWithTableRequest,
  ISyncFormMetadataWithWorkflowBoRequest,
  IUnlinkFormFromSourceRequest
} from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

export class FormService {
  static backendUrl: string = CommonHelperFunctions.GetBackendUrl();

  public static async MigrateFormMetadata(
    request: IMigrateFormMetadataRequest
  ): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      return await Axios.post<IMigrateFormMetadataRequest, AxiosResponse<ICRUDFormDiMetadata>>(
        `${FormService.backendUrl}/form/migrateformmetadata`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async SyncFormMetadataWithAction(
    request: ISyncFormMetadataWithActionRequest
  ): Promise<AxiosResponse<ICRUDSyncFormMetadataWithActionResponse>> {
    try {
      return await Axios.post<
        ISyncFormMetadataWithActionRequest,
        AxiosResponse<ICRUDSyncFormMetadataWithActionResponse>
      >(`${FormService.backendUrl}/form/syncformmetadatawithaction`, request);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async SyncFormMetadataWithTable(
    request: ISyncFormMetadataWithTableRequest
  ): Promise<AxiosResponse<ICRUDSyncFormMetadataWithTableResponse>> {
    try {
      return await Axios.post<ISyncFormMetadataWithTableRequest, AxiosResponse<ICRUDSyncFormMetadataWithTableResponse>>(
        `${FormService.backendUrl}/form/syncformmetadatawithtable`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async SyncFormMetadataWithWorkflowBo(
    request: ISyncFormMetadataWithWorkflowBoRequest
  ): Promise<AxiosResponse<ICRUDSyncFormMetadataWithWorkflowResponse>> {
    try {
      return await Axios.post<
        ISyncFormMetadataWithWorkflowBoRequest,
        AxiosResponse<ICRUDSyncFormMetadataWithWorkflowResponse>
      >(`${FormService.backendUrl}/form/syncformmetadatawithworkflow`, request);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async UnlinkFormFromSource(
    request: IUnlinkFormFromSourceRequest
  ): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      return await Axios.post<IUnlinkFormFromSourceRequest, AxiosResponse<ICRUDFormDiMetadata>>(
        `${FormService.backendUrl}/form/unlinkformfromsource`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetFormMetadataFromAction(
    request: IGetFormMetadataFromActionRequest
  ): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      return await Axios.post<IGetFormMetadataFromActionRequest, AxiosResponse<ICRUDFormDiMetadata>>(
        `${FormService.backendUrl}/form/getformmetadatafromaction`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetFormMetadataFromWorkflowBo(
    request: IGetFormMetadataFromWorkflowBoRequest
  ): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      return await Axios.post<IGetFormMetadataFromWorkflowBoRequest, AxiosResponse<ICRUDFormDiMetadata>>(
        `${FormService.backendUrl}/form/getformmetadatafromworkflowbo`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetFormMetadataFromDataTable(
    request: IGetFormMetadataFromDataTableRequest
  ): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      return await Axios.post<IGetFormMetadataFromDataTableRequest, AxiosResponse<ICRUDFormDiMetadata>>(
        `${FormService.backendUrl}/form/getformmetadatafromdatatable`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetFormMetadataFromExcel(
    request: IGetFormMetadataFromExcelRequest
  ): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      return await Axios.post<IGetFormMetadataFromExcelRequest, AxiosResponse<ICRUDFormDiMetadata>>(
        `${FormService.backendUrl}/form/getformmetadatafromexcel`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetFormDiCustom(request: ICRUDGetFormDiCustomRequest): Promise<AxiosResponse<IDisplayItem>> {
    try {
      return await Axios.post<ICRUDGetFormDiCustomRequest, AxiosResponse<IDisplayItem>>(
        `${FormService.backendUrl}/form/getformdicustom`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetFormMetadataForStartProcess(request: {
    processId: string;
  }): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      return await Axios.post<IGetFormMetadataFromWorkflowBoRequest, AxiosResponse<ICRUDFormDiMetadata>>(
        `${FormService.backendUrl}/form/getformmetadataforstartprocess`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
